/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import { CacheType, createObservableDataAction, IAction, IActionContext, IActionInput } from '@msdyn365-commerce/core';
import {createContactAsync} from '../generated/DataActionExtension.g';
import { IDXC_ContactResponse } from '../generated/DataServiceEntities.g';

/**
 * SubmitContactFormDataActionInput Input Action
 */

export class SubmitContactFormDataActionInput implements IActionInput {
    public name: string;
    public emailAddress: string;
    public occupation: string;
    public phoneNumber: string;
    public enquiry: string;
    public checkbox: boolean

    // Construct the input needed to run the action
    constructor(name: string, emailAddress: string,occupation: string, phoneNumber: string, enquiry: string, checkbox:boolean) {
        this.name = name;
        this.emailAddress = emailAddress;
        this.occupation = occupation;
        this.phoneNumber = phoneNumber;
        this.enquiry = enquiry;
        this.checkbox = checkbox
    }

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => 'ContactForm2020';
    public getCacheObjectType = () => 'ContactForm';
    public dataCacheType = (): CacheType => 'request';
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInput = (args: SubmitContactFormDataActionInput): IActionInput => {
    return args;
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
export async function submitContactFormAction(
    input: SubmitContactFormDataActionInput,
    ctx: IActionContext
): Promise<IDXC_ContactResponse> {
    // Input only needs token
    let result: IDXC_ContactResponse = { success: false };
    try {
       result = await createContactAsync({ callerContext: ctx }, input.name, input.emailAddress, input.phoneNumber, input.occupation, '' ,'Commercial Enquiry', input.enquiry)
        // result = await createContactCommercialAsync({ callerContext: ctx }, input.name, input.emailAddress,input.occupation, input.phoneNumber, input.enquiry, input.checkbox);
    } catch (error) {
        console.log(error);
    }
    return Array.isArray(result) ? result[0] : result;
}

export const ISubmitContactFormDataActionAction = createObservableDataAction({
    action: <IAction<IDXC_ContactResponse>>submitContactFormAction,
    input: createInput
});